/* 06.10.2026 LUX perf (theme-own code only, no tracking/app code).
 * Must load BEFORE critical.js (both deferred, executed in document order).
 * 1) Below-the-fold <swiper-section> sliders initialise when they come near the viewport.
 *    Sliders already in/near the first screen, thumb-linked sliders, and browsers without
 *    IntersectionObserver initialise immediately = unchanged behaviour.
 * 2) Collection sort/pagination hygiene now that grids are paginated by 16:
 *    - changing sort resets ?page= (otherwise page 2 of the new order is shown)
 *    - pagination links in section-rendered HTML never carry the internal ?sections= param. */
(function () {
  try {
    var define = customElements.define.bind(customElements);
    customElements.define = function (name, ctor, opts) {
      if (name === 'swiper-section' && ctor && ctor.prototype && !ctor.prototype._luxLazy) {
        var proto = ctor.prototype;
        var origConnected = proto.connectedCallback;
        var origDisconnected = proto.disconnectedCallback;
        proto._luxLazy = true;

        var isEager = function (el) {
          if (el.dataset && el.dataset.thumbs) return true;
          var thumbs = document.querySelectorAll('swiper-section[data-thumbs]');
          for (var i = 0; i < thumbs.length; i++) {
            var cls = thumbs[i].dataset.thumbs;
            if (cls && (el.querySelector('.' + cls) || (el.classList && el.classList.contains(cls)))) return true;
            if (cls && el.querySelector('.swiper') && el.querySelector('.swiper').classList.contains(cls)) return true;
          }
          return false;
        };

        proto.connectedCallback = function () {
          var el = this;
          if (el._luxReady) return origConnected.call(el);
          if (el._luxIO) return;
          var start = function () {
            if (el._luxIO) { el._luxIO.disconnect(); el._luxIO = null; }
            el._luxReady = true;
            origConnected.call(el);
          };
          var r = el.getBoundingClientRect();
          var nearViewport = r.top < (window.innerHeight || 800) + 400;
          if (nearViewport || !('IntersectionObserver' in window) || isEager(el)) return start();
          el._luxIO = new IntersectionObserver(function (entries) {
            for (var i = 0; i < entries.length; i++) if (entries[i].isIntersecting) { start(); return; }
          }, { rootMargin: '400px 0px' });
          el._luxIO.observe(el);
        };
        proto.disconnectedCallback = function () {
          if (this._luxIO) { this._luxIO.disconnect(); this._luxIO = null; }
          if (origDisconnected) return origDisconnected.call(this);
        };
      }
      return define(name, ctor, opts);
    };
  } catch (e) { /* fall back to eager init */ }

  try {
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('select[name="sort_by"]')) {
        var u = new URL(window.location.href);
        if (u.searchParams.has('page')) {
          u.searchParams.delete('page');
          window.history.replaceState({}, '', u.toString());
        }
      }
    }, true);
    document.addEventListener('collection-grid-update', function () {
      document.querySelectorAll('.pagination-wrapper a[href*="sections="]').forEach(function (a) {
        var u = new URL(a.getAttribute('href'), window.location.origin);
        u.searchParams.delete('sections');
        a.setAttribute('href', u.pathname + u.search);
      });
    });
  } catch (e) {}
})();
